import {useCallback, useEffect} from "react";
import {useErrorHandler} from "~/components/ErrorHandling";
import {useGetReleaseNoteListQuery, useGetReleaseNoteQuery} from "~/queries"



export const useReleaseNote = (version: string) => {
    const handleError = useErrorHandler();
    const {data, loading, error, refetch} = useGetReleaseNoteQuery({
        notifyOnNetworkStatusChange: true,
        variables: {
            version: version
        }
    });

    useEffect(() => {
        if (error) {
            handleError(error);
        }
    }, [error])


    return {data: data?.releaseNote, loading: loading || error != null};
}


export const useReleaseNoteList = () => {
    const handleError = useErrorHandler();
    const {data, loading, error, fetchMore: _fetchMore} = useGetReleaseNoteListQuery({
        notifyOnNetworkStatusChange: true,
        variables: {
            first: 20,
            after: null,
        }
    });
    const canFetchMore = Boolean(data?.releaseNotes?.pageInfo?.hasNextPage) && !loading;

    const fetchMore = useCallback(() => {
        if (!canFetchMore) {
            return;
        }
        _fetchMore({
            variables: {
                after: data.releaseNotes.edges[data.releaseNotes.edges.length - 1].cursor,
            }
        }).catch(handleError)
    }, [data, canFetchMore])

    useEffect(() => {
        if (error) {
            handleError(error);
        }
    }, [error])

    return {
        data: data?.releaseNotes?.edges?.map(edge => edge.node),
        loading,
        error,
        fetchMore,
        canFetchMore
    };
}